import React, { useState } from 'react'

import { useActionless, useAppSelector } from 'redux/hooks'
import { SET_ACTIVE_STATE, TOGGLE_MODAL } from 'redux/active/actions/types'

import PackageDetailsOverlay from 'components/newDeckPage/PackageDetailsOverlay'
import PackageSelectorList from 'components/deckPage/modals/cardPackages/PackageList'

type Props = {}

const PackageSelectionOverlay = ({}: Props) => {
  const cardPackageModal = useAppSelector(state => state.active.modals.cardPackageModal)

  const [selectedPackage, setSelectedPackage] = useState<number | null>(null)

  const [setActiveState, toggleModal] = useActionless(SET_ACTIVE_STATE, TOGGLE_MODAL)

  return (
    <>
      <PackageSelectorList
        open={cardPackageModal}
        onClose={() => toggleModal({ modalName: 'cardPackageModal', flag: false })}
        onSelectPackage={setSelectedPackage}
      />

      <PackageDetailsOverlay deckId={selectedPackage} onClose={() => setSelectedPackage(null)} />
    </>
  )
}

export default PackageSelectionOverlay
